import React, { Component } from 'react'
import {
    Redirect,
    Route,
    Switch,
} from 'react-router-dom'
import UnloggedRoute from './shared/unlogged-route'
import NotFoundRoute from './shared/not-found-route'
import { withRouter } from '../validator'
import FrontApp from '../front/components/app'
import RemoteLogin from '../components/auth/remote-login'
import RemoteLogged from '../components/auth/remote-logged'

const PasswordReset = React.lazy(() => import('../components/password-reset'))
const Registration = React.lazy(() => import('../components/auth/registration'))
const Terms = React.lazy(() => import('../components/terms'))
const GroupMembersMobile = React.lazy(() => import('../mobile/components/groups/detail/members'))
const EmailInvitation = React.lazy(() => import('../front/components/shared/email-invitation'))
const GroupEmailInvitation = React.lazy(() => import('../front/components/groups/group-email-invitation'))
const Changelog = React.lazy(() => import('../changelog/index'))
const InfoPage = React.lazy(() => import('../components/info-page'))
const EntityList = React.lazy(() => import('../components/info-page/entity-list/entity-list'))

const LandingSubpage = React.lazy(() => import('../components/landing-subpage'))

@withRouter()
export default class GlobalRoutes extends Component {
    render = () => (
        <React.Suspense fallback={<span />}>
            <Switch>
                <Route exact path={'/fanousek-sportovec'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/turnaje'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/trener'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/pridat-sportoviste'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/o-nas'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/proc-sportnect'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/media'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />
                <Route exact path={'/contact'} render={() => <FrontApp><InfoPage {...this.props} /></FrontApp>} />

                <Route exact path={'/sportuji'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/mlady-sportovec'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/rodice-a-deti'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/trener-instruktor-lektor'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/trenuji-tym-klub'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/organizuji-sportovni-akce'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/fandim-sportu'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/vlastnim-obchod'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/spravuji-sportoviste'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />
                <Route exact path={'/mesta'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />

                <Route exact path={'/seznam-funkci'} render={() => <FrontApp><LandingSubpage {...this.props} /></FrontApp>} />

                <Route exact path={'/seznam-udalosti'} render={() => <FrontApp><EntityList {...this.props} type="events" detailRoute="events" /></FrontApp>} />
                <Route exact path={'/seznam-klubu'} render={() => <FrontApp><EntityList {...this.props} type="groups" detailRoute="clubs" /></FrontApp>} />
                <Route exact path={'/seznam-sportovist'} render={() => <FrontApp><EntityList {...this.props} type="sport-venues" detailRoute="sportVenues" /></FrontApp>} />
                <Route exact path={'/seznam-novinek'} render={() => <FrontApp><EntityList {...this.props} type="news" detailRoute="news" /></FrontApp>} />

                <UnloggedRoute exact path={'/password/reset/:token'} render={() => <FrontApp><PasswordReset {...this.props} /></FrontApp>} />
                <Route exact path={'/terms-and-conditions'} render={() => <FrontApp showNavAndFooter={true}><Terms {...this.props} /></FrontApp>} />
                <UnloggedRoute exact path={'/sign-up'} render={() => <FrontApp><Registration {...this.props} /></FrontApp>} />

                <Redirect exact from={'/why-sportnect'} to="/proc-sportnect" />
                <Redirect exact from={'/cheers-and-athletes'} to="/fanousek-sportovec" />
                <Redirect exact from={'/tournament-organizer'} to="/turnaje" />
                <Redirect exact from={'/clubs-and-teams'} to="/trener" />
                <Redirect exact from={'/about'} to="/o-nas" />
                <Redirect exact from={'/cities'} to="/mesta" />
                <Redirect exact from={'/sport-venue-owner'} to="/pridat-sportoviste" />
                <Redirect exact from={'/parents-and-children'} to="/rodice-a-deti" />

                <Route exact path={'/changelog'} render={() => <FrontApp footerClass="d-none"><Changelog {...this.props} /></FrontApp>} />
                <Route exact path={'/changelog/:type/:changelog'} render={() => <FrontApp><Changelog {...this.props} /></FrontApp>} />

                <Route exact path={'/mobile/clubs/:clubId/members'} render={() => <FrontApp><GroupMembersMobile {...this.props} /></FrontApp>} />

                <Route exact path={'/email-invitation'} render={() => <FrontApp showNavAndFooter={true}><EmailInvitation {...this.props} /></FrontApp>} />
                <Route exact path={'/email-invitation/clubs/:clubId/:hash'} render={() => <FrontApp showNavAndFooter={true}><GroupEmailInvitation {...this.props} /></FrontApp>} />
                <Route exact path={'/email-invitation/clubs/:clubId/:hash/:action'} render={() => <FrontApp showNavAndFooter={true}><GroupEmailInvitation {...this.props} /></FrontApp>} />

                <Route path="/remote-login" exact render={() => <RemoteLogin {...this.props} />}/>
                <Route path="/remote-logged" exact render={() => <RemoteLogged {...this.props} />}/>

                <NotFoundRoute routesType="globalRoutes" />
            </Switch>
        </React.Suspense>
    )
}
